// The header uses antd's default (larger, heavier) font while body cells use a
// smaller custom font, so the same character count needs more pixels in the title.
const HEADER_CHAR_WIDTH_PX = 10;
const BODY_CHAR_WIDTH_PX = 8;
const CELL_PADDING_PX = 48;
const MIN_COLUMN_WIDTH = 100;
const MAX_COLUMN_WIDTH = 320;

const getValueLength = (value: any): number => {
    if (value === null || value === undefined ) return 0;
    return String(value).length;
};

// Sizes a column based on the longer of its title and its widest cell value,
// so a long header (or a long value) doesn't force the table too wide, and the
// title text has enough room to stay on a single line.
export const calculateColumnWidth = (title: string, dataIndex: string, rows: any[]): number => {
    const longestValueLength = (rows || []).reduce((max, row) => {
        const length = getValueLength(row?.[dataIndex]);
        return length > max ? length : max;
    }, 0);
    const titleWidth = (title?.length || 0) * HEADER_CHAR_WIDTH_PX;
    const valueWidth = longestValueLength * BODY_CHAR_WIDTH_PX;
    const width = Math.max(titleWidth, valueWidth) + CELL_PADDING_PX;
    return Math.min(Math.max(width, MIN_COLUMN_WIDTH), MAX_COLUMN_WIDTH);
};

const tableHeaderConverter = (data :any) => {
    if (!Array.isArray(data) || data?.length === 0) return [];

    return Object.keys(data[0])?.map(key => {
        return {
            title: key?.charAt(0)?.toUpperCase() + key?.slice(1),
            dataIndex: key,
            key,
            render: (value: any) => (typeof value === 'boolean' ? (value ? 'True' : 'False') : value)
        };
    });
};

export default tableHeaderConverter;